import "./utils/globalFunctions.js";
import "./kaplay.js";
import "./assets.js";
import "./scenes/play.js";
import "./scenes/pet-game.js";
import "./scenes/shop.js";

// Load  play scene assets

go("main");
// go("play");
